import EmojiPickerPlugin from './plugin/EmojiPickerPlugin';
import emojiPluginTrigger from './utils/emojiPickerPluginTrigger';
import { LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "EmojiPickerPlugin" */ './lazyIndex')
);

export let LazyEmojiPickerPluginClass = createLazyPlugin(
    lazyModule,
    m => m.EmojiPickerPlugin,
    'EmojiPicker',
    emojiPluginTrigger
);

export type LazyEmojiPickerPlugin = LazyPlugin<EmojiPickerPlugin>;
